import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logoMG from '../../assets/logo/logo-mg.png';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isQuienesSomosOpen, setIsQuienesSomosOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Inicio' },
    { 
      path: '/quienes-somos', 
      label: 'Quiénes Somos',
      hasDropdown: true,
      subItems: [
        { path: '/quienes-somos/historia', label: 'Historia' },
        { path: '/quienes-somos/staff', label: 'Staff' },
        { path: '/quienes-somos/proposito', label: 'Propósito' }
      ]
    },
    { path: '/servicios', label: 'Servicios' },
    { path: '/programa-mg', label: 'Programa MG' },
    { path: '/noticias', label: 'Noticias' },
    { path: '/contacto', label: 'Contacto' }
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleQuienesSomosClick = (e) => {
    e.preventDefault();
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={logoMG} alt="MG Logo" className="logo-image" />
          <span className="logo-tagline">ACTIVA TU POTENCIAL</span>
        </Link>

        <button className="menu-toggle" onClick={toggleMenu}>
          <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          {navItems.map((item) => (
            <li 
              key={item.path} 
              className={`navbar-item ${item.hasDropdown ? 'has-dropdown' : ''}`}
              onMouseEnter={() => item.hasDropdown && setIsQuienesSomosOpen(true)}
              onMouseLeave={() => item.hasDropdown && setIsQuienesSomosOpen(false)}
            >
              {item.hasDropdown ? (
                <>
                  <span
                    className={`navbar-link dropdown-trigger ${
                      location.pathname.startsWith('/quienes-somos') ? 'active' : ''
                    }`}
                    onClick={handleQuienesSomosClick}
                  >
                    {item.label}
                    <span className="dropdown-arrow">▼</span>
                  </span>
                  <ul className={`dropdown-menu ${isQuienesSomosOpen ? 'show' : ''}`}>
                    {item.subItems.map((subItem) => (
                      <li key={subItem.path}>
                        <Link
                          to={subItem.path}
                          className={`dropdown-link ${
                            location.pathname === subItem.path ? 'active' : ''
                          }`}
                          onClick={() => setIsMenuOpen(false)}
                        >
                          {subItem.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <Link
                  to={item.path}
                  className={`navbar-link ${location.pathname === item.path ? 'active' : ''}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
